module.exports = __webpack_public_path__ + "static/media/asaas-logo.3f1da0de.svg";